import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Captions, CaptionsOld, CcType, StreamCaptions } from '@modules/preview/types/captions';

@Component({
    selector: 'app-preview-cc',
    templateUrl: './preview-cc.component.html',
    styleUrl: './preview-cc.component.less',
    standalone: false
})
export class PreviewCcComponent implements OnInit {

  // ViewChild
  @ViewChild('cc', { static: false }) ccRef?: ElementRef;

  // Input
  @Input() type: CcType = 'cc1';

  // Public
  public empty = true;

  // Private
  private captions?: CaptionsOld | StreamCaptions;
  private textHtml = '';
  private textareaForDecode = document.createElement('textarea');

  /**
   * Constructor
   */

  constructor() {}

  /**
   * Component lifecycle
   */

  ngOnInit(): void {
  }

  setCaptions(captions: CaptionsOld): void {
    console.log('[Preview][CC] ', captions);
    this.captions = captions;
    const items = this.captions[this.type];
    let textHtml = '';
    // Old CC
    if (items) {
      for (const [key, value] of Object.entries(items)) {
        if (value.windowVisible) {
          textHtml += this.decodeHtml(value.windowText);
        }
      }
    }
    // New CC
    if (captions) {
      textHtml += this.setJsonCaptions(captions as any);
    }
    this.textHtml = textHtml;
    if (this.ccRef) {
      this.ccRef.nativeElement.innerHTML = this.decodeHtml(this.textHtml)
    }
    this.empty = !this.textHtml.length;
  }

  decodeHtml(html: string) {
    this.textareaForDecode.innerHTML = html;
    return this.textareaForDecode.value;
  }

  setJsonCaptions(captions: StreamCaptions): string {
    this.captions = captions;
    if (this.captions) {
      console.log('[ChannelCc][DATA] ', this.captions);
      if (this.captions && this.captions[this.type] && this.captions[this.type]?.length) {
        const cc: Captions = this.captions[this.type]![0];
        let ccHtml = '';
        cc.rows?.forEach(row => {
          let rowHtml = '';
          row.forEach(item => {
            rowHtml += `<span style="${item.style}">${item.text}</span>`
          });
          ccHtml += `<div class="cc-row">${rowHtml}</div>`;
        });
        return ccHtml;
      } else {
        return '';
      }
    }
    return '';
  }

}
